import { render, staticRenderFns } from "./CuentasCobrar.vue?vue&type=template&id=5bea88df"
import script from "./CuentasCobrar.js?vue&type=script&lang=js&external"
export * from "./CuentasCobrar.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports